export default "__VITE_ASSET__SW6H3gVu__"